// composables/usePriceFormatter.ts

export function usePriceFormatter() {
  return { formatPrice }
}

export const formatPrice = (value: number, precision = 1): string => {
  if (value < 1000) return value.toString()

  const units = ["K", "M", "B", "T"]
  let unitIndex = -1

  while (value >= 1000 && unitIndex < units.length - 1) {
    value /= 1000
    unitIndex++
  }
  return `${parseFloat(value.toFixed(precision))}${units[unitIndex]}`
}
